import { useEffect } from 'react';

const OpenCartDownload = () => {
    useEffect(() => {
        // Redirect to actual static file URL
        window.location.href = '/plugins/plugin/opencart.zip';
    }, []);
    return <>
    </>;
};

export default OpenCartDownload;
